import routerOptions0 from "/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}